import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header style={{
      background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
      color: 'white',
      padding: '1rem 2rem',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      boxShadow: '0 4px 20px rgba(5, 150, 105, 0.2)'
    }}>
      <div style={{maxWidth: '1200px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        <Link to="/" style={{fontSize: '1.5rem', fontWeight: '800', color: 'white', display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
          <span style={{fontSize: '1.8rem'}}>💼</span>
          Miranda Landa Services LLC
        </Link>
        
        {/* Desktop Menu */}
        <nav className="hide-mobile" style={{display: 'flex', gap: '2rem', alignItems: 'center'}}>
          <Link to="/" style={{color: 'white', fontWeight: '600', transition: 'opacity 0.3s'}}>Home</Link>
          <Link to="/about" style={{color: 'white', fontWeight: '600', transition: 'opacity 0.3s'}}>About</Link>
          <Link to="/services" style={{color: 'white', fontWeight: '600', transition: 'opacity 0.3s'}}>Services</Link>
          <Link to="/blog" style={{color: 'white', fontWeight: '600', transition: 'opacity 0.3s'}}>Blog</Link>
          <Link to="/faq" style={{color: 'white', fontWeight: '600', transition: 'opacity 0.3s'}}>FAQ</Link>
          <Link to="/contact" style={{color: 'white', fontWeight: '600', transition: 'opacity 0.3s', background: 'rgba(255,255,255,0.2)', padding: '0.5rem 1.5rem', borderRadius: '25px'}}>Get Started</Link>
        </nav>

        {/* Mobile Menu Button */}
        <button 
          className="hide-desktop"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          style={{
            background: 'none',
            border: 'none',
            color: 'white',
            fontSize: '1.5rem',
            cursor: 'pointer'
          }}
        >
          ☰
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <nav className="hide-desktop" style={{
          marginTop: '1rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          paddingTop: '1rem',
          borderTop: '1px solid rgba(255,255,255,0.2)'
        }}>
          <Link to="/" onClick={() => setIsMenuOpen(false)} style={{color: 'white', fontWeight: '600'}}>Home</Link>
          <Link to="/about" onClick={() => setIsMenuOpen(false)} style={{color: 'white', fontWeight: '600'}}>About</Link>
          <Link to="/services" onClick={() => setIsMenuOpen(false)} style={{color: 'white', fontWeight: '600'}}>Services</Link>
          <Link to="/blog" onClick={() => setIsMenuOpen(false)} style={{color: 'white', fontWeight: '600'}}>Blog</Link>
          <Link to="/faq" onClick={() => setIsMenuOpen(false)} style={{color: 'white', fontWeight: '600'}}>FAQ</Link>
          <Link to="/contact" onClick={() => setIsMenuOpen(false)} style={{color: 'white', fontWeight: '600'}}>Get Started</Link>
        </nav>
      )}
    </header>
  );
};

export default Header;
